interface FooterProps {
  version?: string;
}

const Footer = ({ version }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="embed-container col-lg-12 col-md-12 col-sm-12 mb-0 mt-4">
      <p className="text-center">
        &copy; {currentYear}{' '}
        <span className="footer-company">Independent Electricity System Operator (IESO). All rights reserved.</span>
        <span className="footer-simple">IESO</span>
        <span className="footer-separator"> | </span>
        <a href="mailto:adap@ieso.ca" className="footer-support-link" title="Contact Support: adap@ieso.ca" style={{ color: 'inherit', textDecoration: 'none' }}>
          <i className="fa-solid fa-envelope"></i>
          <span className="footer-email-text" style={{ marginLeft: '0.3em', borderBottom: '1px dotted currentColor' }}>adap@ieso.ca</span>
        </a>
        <span className="footer-separator"> | </span>
        {version && <span className="version-info"> v{version}</span>}
      </p>
    </footer>
  );
};

export default Footer;
